import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaSignInAlt, FaSignOutAlt } from "react-icons/fa";
import { FormControl, InputLabel, Select } from "@mui/material";
import { AiOutlineClose } from "react-icons/ai";  
import Popup from "../../../base-components/Popup";

import {
  faCircleCheck,
  faEllipsisV,
  faHistory,
  faInfoCircle,
  faSearch
} from "@fortawesome/free-solid-svg-icons";
import TablePaginationActions from "../../../base-components/TablePaginationActions";
import { Box, Table, TableBody, CircularProgress, TableCell, TableFooter, TableHead, TablePagination, TableRow, Menu, MenuItem, IconButton } from "@mui/material";
import dayjs from "dayjs";
import { getSessionUser, hasPermission, isDynamicStaffRole } from "../../../utils/roleAccess";
import { PageHeader } from "../../../ui";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function StaffAttendance() {
  const navigate = useNavigate();
   const [staff, setStaff] = useState([]);
   const [rowsPerPage, setRowsPerPage] = useState(5);
   const [page, setPage] = useState(0);
   const [loading, setLoading] = useState(false);
   const [anchorEl, setAnchorEl] = useState(null);
   const [selectedMember, setSelectedMember] = useState(null);
   const [role , setRole] = useState('')
   const [company_id , setCompanyID] = useState('')
   const [location_id , setLocationID] = useState('')
  const [filteredattendance, setFilteredAttendance] = useState([]);
   const [isSuccessAlert , setIsSuccessAlert] = useState(false)
   const [isFaliureAlert , setIsFailureAlert] = useState(false)
   const [successMessage , setSuccessMessage] = useState('')
   const [failureMessage , setFailureMessage] = useState('')
   const [isPopupOpen , setIsPopupOpen] = useState(false)
 const [searchQuery, setSearchQuery] = useState("");
 const [checkInButtonLoading, setCheckInButtonLoading] = useState(false);
 const [checkOutButtonLoading, setCheckOutButtonLoading] = useState(false);
 const [markAsAbsentButtonLoading, setMarkAsAbsentButtonLoading] = useState(false);
 const [selectedStaffMember, setSelectedStaffMember] = useState(null);

   useEffect(()=> {
          const sessionStr = sessionStorage.getItem('user-info');
          if(sessionStr){
            const session = JSON.parse(sessionStr);
            setRole(session.user.role)
            setCompanyID(session.user.company_id)
            setLocationID(session.user.location_id)
          }
           else {
            navigate('/login');
          }
    },[])

  useEffect(() => {
    if(role) {
      const fetchData = async () => {
        setLoading(true);
        try {
          await Promise.all([
            getAllStaffmember()
          ])
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false);
        }
      };
      fetchData();
    }
  }, [role]);

  const getAllStaffmember = () => {
    if (!role) return;

    let endpoint = "";
    console.log(role);
    if (role === "SuperAdmin") {
      endpoint = `staff/get-staff`;
    } else if (role === "Admin") {
      endpoint = `staff/get-staff-by-company-id/${company_id}`;
    } else if (role === "ClubAdmin") {
      endpoint = `staff/get-staff-by-location-id/${location_id}`;
    } else if (isDynamicStaffRole(role)) {
      endpoint = `staff/get-staff-by-location-id/${location_id}`;
    }

    console.log("Role:", role);
    console.log("Company ID:", company_id);
    console.log("Endpoint:", endpoint);
    fetch(BASE_URL + endpoint)
      .then((response) => response.json())
      .then((data) => {
        setStaff(data.staff); 
        setFilteredAttendance(data.staff);
        setLoading(false); 
      })
      .catch((error) => {
        console.error("Error fetching staff assets:", error); 
        setLoading(false); 
      });
  };
console.log("hgsd",staff)
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  
  const handleCreateAttendance = async(status , staff) => {
    status === 'checked-in' ? setCheckInButtonLoading(true) : status === 'checked-out' ? setCheckOutButtonLoading(true) : setMarkAsAbsentButtonLoading(true);
    setSelectedStaffMember(staff._id);
    const data = {
      staff_id : staff._id,
      location_id : staff?.location_id,
      status
    }
console.log(data,"dataaaaaaaaa")
    setLoading(true);

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    };

    try{
      const response = await fetch(BASE_URL + `staffattendance/createStaffAttendance`, requestOptions);
      if(!response.ok) {
        const data = await response.json();
        console.error('Response not ok:', data);
        setIsFailureAlert(true);
        setFailureMessage(data.message);
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      }else {
       
        setIsSuccessAlert(true);
        if (status === "absent") {
          setSuccessMessage('Leave Marked Successfully');
        } else {
          setSuccessMessage('Attendance Marked Successfully');
        }
        // setSuccessMessage('Attendance Marked Successfully');
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      }
    } catch (err) {
        console.error('Caught error:', err);
        setIsFailureAlert(true);
        setFailureMessage('Failed to Mark Attendance');
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
    } finally {
      setCheckInButtonLoading(false);
      setCheckOutButtonLoading(false);
      setMarkAsAbsentButtonLoading(false);
      setSelectedStaffMember(null);
      setLoading(false)
    }
  
  }

  const handleMoreOptions = (event, att) => {
    setAnchorEl(event.currentTarget);
    setSelectedMember(att);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedMember(null);
  };


let filteredAttendance;
  const handleSearch = (search) => {
    setSearchQuery(search);
  

    if (!search) {
        setFilteredAttendance(staff);
        return;
    }
    else{

 
    filteredAttendance = staff.filter((staffs) => 
        staffs.name.toLowerCase()?.includes(search.toLowerCase()) 
    ); 
    console.log("hg",filteredAttendance)
     setFilteredAttendance(filteredAttendance);
    }
};



  return (
    <>
    
      <div className="m-5">
        <PageHeader title="Staff Member Attendance" />
      </div>
      <div className="relative w-auto mx-5 flex items-center gap-4">
  <div className="relative">
    <FontAwesomeIcon icon={faSearch} className="absolute left-3 top-2 text-gx-ink-soft" />
    <input
      type="text"
      placeholder="Search..."
      value={searchQuery}
      onChange={(e) => handleSearch(e.target.value)}
      className="border border-gx-border rounded-md py-1 px-2 pl-10 outline-0 w-72"
    />
  </div>
</div>
 
      { loading ? (
         
            <div className="flex justify-center items-center mt-20 relative">
              {/* SVG Gradient Definition */}
              <svg width="0" height="0">
                <defs>
                  <linearGradient id="gradientColors" x1="1" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#D71920" />
                    <stop offset="100%" stopColor="#F7931E" />
                  </linearGradient>
                </defs>
              </svg>
      
              {/* Circular Progress with Gradient Stroke */}
              <CircularProgress
                thickness={4}
                size={35}
                sx={{
                  'svg circle': {
                    stroke: 'url(#gradientColors)', // Apply gradient stroke
                  },
                }}
              />
            </div>
        
        ) :  filteredattendance && filteredattendance.length !== 0 ? (
        <Box className="bg-gx-surface rounded-gx border border-gx-border shadow-gx m-5 animate-fadeIn overflow-y-auto overflow-x-auto">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Contact No</TableCell>
                <TableCell>Hire Date</TableCell>
                {/* <TableCell>Created  by</TableCell> */}
                <TableCell>Created At</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {filteredattendance
  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  .map((staff, index) => (
                <TableRow hover key={index}>
                  <TableCell>{staff.name}</TableCell>
                  <TableCell>{staff.email}</TableCell>
                  <TableCell>{staff.phone_number}</TableCell>
                  <TableCell>{dayjs(staff.hire_date).format('MMM DD, YYYY')}</TableCell>
                  <TableCell>{dayjs(staff.created_at).format('MMM DD, YYYY')}</TableCell>

                  
                  <TableCell>
                    <div className="flex gap-4 justify-center items-center">
                   

    {hasPermission(getSessionUser(), 'staff_attendance:mark_attendance') && (
    <button className={`flex items-center  px-2 py-2 bg-green-600 text-white rounded-lg text-medium font-semibold shadow-md hover:bg-green-700 transition ${checkInButtonLoading && staff._id === selectedStaffMember ? "cursor-not-allowed bg-gray-400" : ""}`}
    onClick={() => handleCreateAttendance('checked-in', staff)}>
          <FaSignInAlt size={20} className="mr-2"/>
          Check-in {checkInButtonLoading && staff._id === selectedStaffMember && <CircularProgress size={20} className="ml-2 mt-1" sx={{ color: "white" }} />}
        </button>
    )}

        {hasPermission(getSessionUser(), 'staff_attendance:mark_attendance') && (
        <button className={`flex items-center  px-2 py-2 bg-red-600 text-white rounded-lg text-medium font-semibold shadow-md hover:bg-red-700 transition ${checkOutButtonLoading && staff._id === selectedStaffMember ? "cursor-not-allowed bg-gray-400" : ""}`}
        onClick={() => handleCreateAttendance('checked-out', staff)}>
          <FaSignOutAlt size={20} className="mr-2" />
          Check-out {checkOutButtonLoading && staff._id === selectedStaffMember && <CircularProgress size={20} className="ml-2 mt-1" sx={{ color: "white" }} />}
        </button>
        )}

        {hasPermission(getSessionUser(), 'staff_attendance:mark_attendance') && (
        <button className={`flex items-center  px-2 py-2 bg-red-600 text-white rounded-lg text-medium font-semibold shadow-md hover:bg-red-700 transition ${markAsAbsentButtonLoading && staff._id === selectedStaffMember ? "cursor-not-allowed bg-gray-400" : ""}`}
        onClick={() => handleCreateAttendance('absent', staff)}>
          <FaSignOutAlt size={20} className="mr-2" />
          Mark as Absent {markAsAbsentButtonLoading && staff._id === selectedStaffMember && <CircularProgress size={20} className="ml-2 mt-1" sx={{ color: "white" }} />}
        </button>
        )}

                      {/* More Options */}
                      <IconButton
                        color="default"
                        onClick={(event) => handleMoreOptions(event, staff)}
                        aria-label="More"
                      >
                        <FontAwesomeIcon icon={faEllipsisV} />
                      </IconButton>

                      {/* Dropdown Menu */}
                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl) && selectedMember === staff}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                      >
                        <MenuItem onClick={() => navigate(`/staffhistory/${staff._id}`)}>
                          <FontAwesomeIcon icon={faHistory} className="mr-2" />
                          Staff History
                        </MenuItem>
                        <MenuItem  onClick={() => navigate(`/staffprofile/${staff._id}`,{state:{data:staff}})}>
                          <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />
                          Staff Details
                        </MenuItem>
                      </Menu>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  colSpan={6}
                  count={filteredattendance.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  slotProps={{
                    select: {
                      inputProps: {
                        "aria-label": "rows per page",
                      },
                      native: true,
                    },
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </Box>
      ) : (
        <div className="bg-gx-border w-auto p-3 mt-10 rounded-lg m-10">
          <h3 className="text-xl font-bold text-center text-gx-ink-soft">
            No Records Found
          </h3>
        </div>
      )}
    

{
  isPopupOpen && (
    <Popup
    onClose={() => setIsPopupOpen(false)}
    alertType={isSuccessAlert ? 'success' : isFaliureAlert ? 'failure' : ''}
    message={isSuccessAlert ? successMessage : isFaliureAlert ? failureMessage : ''}
    />
  )
}
</>
  );
}

export default StaffAttendance;
